import styled, { css } from 'styled-components';

import BackIcon from 'components/BackIcon/BackIcon';
import CloseIcon from 'components/CloseIcon/CloseIcon';
import { mediaDesktop } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

export const OpportunityOverlayWrapperWrapper = styled.div``;

export const CloseIconComp = styled(CloseIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: ${layout.zIndex.menuModal};

  ${mediaDesktop(css`
    top: 32px;
    right: 32px;
  `)}
`;

export const BackIconComp = styled(BackIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: ${layout.zIndex.menuModal};

  ${mediaDesktop(css`
    top: 32px;
    right: 32px;
  `)}
`;
